import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { type Department } from '@/types/org';
import { type UserProfile } from '@/types/team';
import { GamutLogo } from '@/components/ui/GamutLogo';
import { EnvironmentBadge } from '@/components/ui/EnvironmentBadge';
import { UserMenu } from '@/components/layout/UserMenu';

interface PhoneAppBarProps {
    home: string;
    profile: UserProfile | null;
    departments: Department[];
    profileLink: string;
    signOut: () => Promise<void>;
    onOpenNavigation: () => void;
}

/**
 * WEB-111 increment 4 (Jason, 2026-10-31, from an Android screenshot of the Willis job: "not enough working space"):
 * below md the shell is ONE 56 px bar - menu, logo, environment badge, account. The org and office title, the org
 * switcher, the Platform admin chip, the job cost estimate and Create Job moved into the drawer (PhoneDrawerActions);
 * before, they took two rows (about 64 px plus a wrap) on every page.
 */
export const PhoneAppBar: React.FC<PhoneAppBarProps> = ({ home, profile, departments, profileLink, signOut, onOpenNavigation }) => (
    <header data-testid="phone-app-bar" className="h-14 shrink-0 flex items-center gap-2 px-3 border-b border-divider-subtle bg-bg-primary/60 backdrop-blur-xl z-30">
        <button
            type="button"
            onClick={onOpenNavigation}
            aria-label="Open navigation"
            className="shrink-0 w-11 h-11 flex items-center justify-center rounded-xl bg-bg-secondary/60 border border-divider-subtle text-text-primary"
        >
            <Menu size={20} />
        </button>
        <Link to={home} aria-label="Gamut home" className="shrink-0 flex items-center">
            <GamutLogo alt="Gamut" className="w-8 h-8 object-contain" />
        </Link>
        <EnvironmentBadge inline />
        <div className="flex-1" />
        <UserMenu profile={profile} departments={departments} profileLink={profileLink} signOut={signOut} />
    </header>
);
